<template>
    <div class="study-room">
        <TopMenu></TopMenu>
        <Carousel></Carousel>
         <van-tabs v-model="activeName" @click="handleClick">
                <van-tab title="广西" name="gx">
                    <Nav></Nav>
                    <Column title="高中教育" v-if="highSchoolList.length > 0">
                        <List :list="highSchoolList.slice(0,4)" :name="`${encodeURI('高中教育')}`"></List>
                    </Column>
                    <Column title="初中教育" v-if="juniorHighList.length > 0">
                        <List :list="juniorHighList.slice(0,4)" :name="`${encodeURI('初中教育')}`"></List>
                    </Column>
                    <Column title="小学教育" v-if="primaryList.length > 0">
                        <List :list="primaryList.slice(0,4)" :name="`${encodeURI('小学教育')}`"></List>
                    </Column>
                    <Column title="防疫公益广告" v-if="epidEmic.length > 0">
                        <List :list="epidEmic.slice(0,4)"></List>    
                    </Column>
                    <Ad></Ad>
                    <Loading :show="isUa && isLoading"></Loading>  
                </van-tab>
                <van-tab title="桂林" name="gl">桂林</van-tab>
                <van-tab title="防城港" name="fcg">防城港</van-tab>
                <van-tab title="北海" name="bh">北海</van-tab>
                <van-tab title="百色" name="bs">百色</van-tab>
                <van-tab title="贺州" name="hz">贺州</van-tab>
                <van-tab title="梧州" name="wz">梧州</van-tab>
            </van-tabs>
        

        <!-- <Column title="正在播出">
            <div class="video-box">
                <Video></Video>    
            </div> 
        </Column> -->

          
    </div>
</template>

<script>
import jsonp from 'jsonp';
import Carousel from "./carousel";
import Nav from "./nav";
import TopMenu from "./page/module/topmenu";
import Video from "./video"
import Column from "./column";
import List from "./list";
import Ad from "./ad";
import Loading from "../loading"
//import {Tabs,TabPane} from 'element-ui';
import { Tab, Tabs} from 'vant'
import router from 'vue-router';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';

export default{
    name: 'Study',
    data(){
        return{
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            primarySchool: [50946,50947,50948,50949,50950,50951].join(','),     //小学
            juniorHighSchool: [50952,50953,50954].join(','),    //初中
            highSchool: [50955,50956,50957].join(','),  //高中
            primaryList: [],
            juniorHighList: [],
            highSchoolList: [],
            epidEmic: [],
            activeName: 'gx'  
        }
    },
    created(){
        this.getData(this.primarySchool, 'primarySchool');
        this.getData(this.juniorHighSchool, 'juniorHighSchool');
        this.getData(this.highSchool, 'highSchool');
        this.getStatistPv();    
    },
    mounted(){
        document.title = "壮观客户端《广西中小学空中课堂》正在开课，权威授权！";
        if(window.location.href.indexOf('h5') > 0){
            window.location.href = 'http://byte.gxnews.com.cn/zg/#/study';    
        }
    },
    methods:{
        getData(level, name){
            this.isLoading = true;
            this.axios.get(`/data/${name}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                switch(name){
                    case 'primarySchool':
                        this.primaryList = res.data.courselist;
                        break;
                    case 'juniorHighSchool':
                        this.juniorHighList = res.data.courselist;
                        break;
                    case 'highSchool':
                        this.highSchoolList = res.data.courselist;
                        break;
                }
            })
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fstudy&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        },
        handleClick(name, title) {
            if(name=='gl'){
                this.$router.push({path:"/dishi/桂林市空中课堂/"+name});
            }
            if(name=='fcg'){
                this.$router.push({path:"/dishi/防城港市空中课堂/"+name});
            }
            if(name=='bh'){
                this.$router.push({path:"/dishi/北海市空中课堂/"+name});
            }
            if(name=='bs'){
                this.$router.push({path:"/dishi/百色市空中课堂/"+name});
            }
            if(name=='hz'){
                this.$router.push({path:"/dishi/贺州市空中课堂/"+name});
            }
	     if(name=='wz'){
                this.$router.push({path:"/dishi/梧州市空中课堂/"+name});
            }
        }
    },
    components: {
        Carousel,
        Nav,
        TopMenu,
        Video,
        Column,
        List,
        Ad,
        Loading,
        Tab,
        Tabs
    }
}
</script>

<style lang="less" scoped>
    .study-room{
        padding-top: 1rem;
        padding-bottom: 2rem;
        margin-top: 16px;
        .video-box{
            padding-bottom: 0.2rem;
        }
    }
  
</style>   